<template>
    <!-- Sorteios com inscrição pública aberta (some quando não há nenhum). -->
    <section v-if="sorteios.length" class="pb-6" aria-labelledby="titulo_sorteios">
        <div class="flex items-center gap-2 mb-3">
            <Gift class="w-5 h-5 text-admin-primary" />
            <h2 id="titulo_sorteios" class="text-lg font-bold text-admin-primary">Sorteios com inscrições</h2>
        </div>

        <div class="grid grid-cols-1 gap-3" :class="{ 'sm:grid-cols-2': sorteios.length > 1 }">
            <article v-for="sorteio in sorteios" :key="sorteio.code"
                class="flex gap-4 p-4 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                <div class="w-16 h-16 flex-shrink-0 rounded-xl overflow-hidden bg-gray-50 border border-gray-100 flex items-center justify-center">
                    <img v-if="sorteio.logo_url" :src="sorteio.logo_url" :alt="sorteio.descricao" class="w-full h-full object-contain" loading="lazy" />
                    <Trophy v-else class="w-7 h-7 text-admin-primary/60" />
                </div>

                <div class="flex-1 min-w-0 flex flex-col">
                    <div class="flex items-start justify-between gap-2">
                        <h3 class="font-bold text-gray-800 leading-snug break-words">{{ sorteio.descricao }}</h3>
                        <span class="flex-shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide"
                            :class="sorteio.situacao_inscricoes === 'abertas' ? 'bg-emerald-100 text-emerald-700' : 'bg-sky-100 text-sky-700'">
                            {{ sorteio.situacao_inscricoes === 'abertas' ? 'Inscrições abertas' : 'Em breve' }}
                        </span>
                    </div>
                    <p class="mt-1 flex items-center gap-1.5 text-xs text-gray-500">
                        <CalendarClock class="w-3.5 h-3.5 flex-shrink-0" />
                        <template v-if="sorteio.situacao_inscricoes === 'abertas'">Inscrições até {{ formatarData(sorteio.data_final) }}</template>
                        <template v-else>Inscrições a partir de {{ formatarData(sorteio.data_inicio) }}</template>
                    </p>

                    <div class="mt-3 flex flex-wrap gap-2">
                        <a v-if="sorteio.situacao_inscricoes === 'abertas'" :href="sorteio.url_inscricao"
                            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-admin-primary hover:bg-admin-primary-dark text-white text-sm font-medium transition-colors">
                            <UserPlus class="w-4 h-4" />
                            {{ sorteio.modo_sorteio === 'residencial' ? 'Fazer inscrição' : 'Inscrever aluno' }}
                        </a>
                        <a :href="sorteio.url_telao" target="_blank" rel="noopener"
                            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-admin-primary text-admin-primary hover:bg-admin-primary hover:text-white text-sm font-medium transition-colors">
                            <MonitorPlay class="w-4 h-4" />
                            Acompanhar
                        </a>
                    </div>
                </div>
            </article>
        </div>
    </section>
</template>

<script setup>
import { Gift, Trophy, CalendarClock, UserPlus, MonitorPlay } from 'lucide-vue-next'

defineProps({
    // [{ code, descricao, logo_url, data_inicio, data_final, situacao_inscricoes, url_inscricao, url_telao }]
    sorteios: { type: Array, default: () => [] },
})

const formatarData = (data) => new Date(data).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
</script>
